module.exports = new __parcel__URL__("report-version.0a75365e.svg").toString();